export default "__VITE_ASSET__DKWiXwpK__"